let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dGWgd")).then(() => parcelRequire('3mbDA'));